import { Box, Typography } from '@mui/material';
import { FC, Fragment, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as FailureIconVs } from 'src/assets/svg/failure-red-circle.svg';
import { ReactComponent as FailureIconHos } from 'src/assets/svg/failure-red-circle-hos.svg';
import { Button } from 'src/components/button';
import { removeStorage } from 'src/utils/local-storage-versioning';
import { appConfig } from 'src/app';
import { getTheme } from 'src/utils/getTheme';

import { styles } from './styles';

const { isHosTheme } = getTheme();

const FailureIcon: FC = () => (isHosTheme ? <FailureIconHos /> : <FailureIconVs />);

const TextWrapper: FC<{ children: ReactNode }> = (props) => {
    const Wrapper = isHosTheme ? Box : Fragment;

    return <Wrapper>{props.children}</Wrapper>;
};
export const NoRoomSelected: FC = () => {
    const { t } = useTranslation();
    const { vs, hos } = appConfig.brochureSiteUrl;
    removeStorage();

    return (
        <Box css={styles.container}>
            <Box css={styles.imageContainer} />

            <Box css={styles.wrapper}>
                <FailureIcon />

                <TextWrapper>
                    <Typography variant="h1" css={styles.title}>
                        {t('no_room_selected_title')}
                    </Typography>

                    <Typography variant="body3">{t('no_room_selected_content')}</Typography>
                </TextWrapper>

                <Button
                    {...(isHosTheme && { design: 'light', bordered: true })}
                    variant="contained"
                    css={styles.cta}
                    href={isHosTheme ? hos : vs}
                >
                    {t('room_not_available_btn')}
                </Button>
            </Box>
        </Box>
    );
};
